import React, { useEffect, useState } from "react";
import { ApiURL } from "../../../../../services/apiConstants";
import { post } from "../../../../../services/services";
import SisLoader from "../../../../../widgets/loader";
import FramoDetailsTable from "../../components/CargoCraneCom/FramoRow";

function StaffFramo({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchFramoList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_cargo_machinery_framo_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.framo_parameters_data || []);
      }
    } catch (error) {
      console.error("Error fetching Framo list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchFramoList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>Framo Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <FramoDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffFramo;
